class F360Constant {
		
	lactDefault1: 						number =   60;
	lactDefault2: 						number =   74;
	timeInterval: 						number =   20000;
	timeCheckOnlineSecPage: 			number =   5000;
	timeCheckOnline: 					number =   1000;
	initialCheckF360SyncInterval: 		number =   1000;
	initialUpdateSyncIndicatorInterval: number =   1000;
	updateSyncIndicatorInterval: 		number =   3000;
	checkF360SyncInterval: 				number =   5000;
	scrollNumberSection: 				number =   170;
	locationMinium: 					number =   6;
	numberMedML: 						number =   5;
	numberMaxML: 						number =   8;
	// IndexedDB
	getStaticListAll: 					string =   'getStaticListAll';
	getAuditList: 						string =   'getListByHerdId';
	getPrograms: 						string =   'getHerdFertilityProgramsByHerdId';
	getOverViewList: 					string =   'getOverViewList';
	getQuestionList: 					string =   'getQuestionList';
	getAnswerList: 						string =   'getAnswerList';
	getReviewResultsAndDraft: 			string =   'getReviewResultsAndDraft';
	getTerritoryManagerForFarm: 		string =   'getTerritoryManagerForFarm';
	getHerdsByFarmId: 					string =   'getHerdsByFarmId';
	getList: 							string =   'getList';
	getListherds: 						string =   'getListherds';
	getPrePopulatedData: 				string =   'getPrePopulatedData';
	getPenListData: 					string =   'getPenListData';
	getFarm:							string =   'getFarm';
	// localStorage
	codeFile: 							string =   'codeFile';
	availableFarms: 					string =   'availableFarms';
	availableHerds: 					string =   'availableHerds';
	keySectionScroll: 					string =   'key_section_scroll';
	questionNumberCowsInPen: 			string =   'Number of Cows in Pen';
	questionAverageBCS: 				string =   'Average Body Condition Score';
	questionAverageLS: 					string =   'Average Lameness Score';
	questionNotApplicable: 				string =   'Not Applicable - Dry cows not separated or far-off dry cows kept off site';
	questionStockDensity: 				string =   'Stocking Density at Feedbunk';
	questionOverallDataQuality: 		string =   'Overall Data Quality';
	questionTurnoverRate: 				string =   'Turnover Rate';
	questionCowPersonnelRatio: 			string =   'Number of Cows per Employee';
	questionChngBSCDryCowsCloseFar: 	string =   'Change in BCS Between Dry Cows Far-Off & Close-Up';
	questionChngBSCDryCowsFreshClose: 	string =   'Change in BCS Between Dry Cows Close-Up & Fresh Cows';
	answerTrue: 						string =   'T';
	answerFalse: 						string =   'F';
	
	constructor() {

	}

}

angular.module('mySynch').service('F360Constant',F360Constant );

